const cache = new Map();

export async function reverseGeocode(lat, lon) {
  const key = lat.toFixed(3) + ',' + lon.toFixed(3);
  if (cache.has(key)) return cache.get(key);

  const url =
    'https://api.bigdatacloud.net/data/reverse-geocode-client' +
    `?latitude=${lat}&longitude=${lon}&localityLanguage=en`;

  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const d = await res.json();

  const place = d.city || d.locality || d.principalSubdivision || '';
  const country = d.countryName || '';
  const label =
    [place, country].filter(Boolean).join(', ') ||
    (d.localityInfo?.administrative?.[0]?.name ?? 'Open ocean');

  cache.set(key, label);
  return label;
}
